import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl, setFormDataV2 } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class RouteStandingOrderService {

  constructor(private http: HttpClient) { }

  getRouteStandingOrders(queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.ROUTE_STANDING_ORDER_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  saveRouteStandingOrders(id, payload) {

    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.ROUTE_STANDING_ORDER_URL + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ROUTE_STANDING_ORDER_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getRouteStandingOrdersbyId(id) {
    return this.http.get<any>(urls.BASE_URL + urls.ROUTE_STANDING_ORDER_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  deleteRouteStandingOrder(id) {
    return this.http.delete<any>(urls.BASE_URL + urls.ROUTE_STANDING_ORDER_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }


}
